import { createSelector } from 'reselect';

const selectScheduledTasksConfigurations = (state: any) => state.scheduledTasksConfigurations;


export const selectScheduledTasksConfigurationsCurrentItem = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.current);

export const selectScheduledTasksConfigurationsListItems = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.list);

export const selectScheduledTasksConfigurationsItemById = (itemId: any) =>
    createSelector(selectScheduledTasksConfigurationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectScheduledTasksConfigurationsQueryItems = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.query);

export const selectScheduledTasksConfigurationsCreatedItem = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.create);

export const selectScheduledTasksConfigurationsUpdatedItem = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.update);

export const selectScheduledTasksConfigurationsReadItem = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.read);

export const selectScheduledTasksConfigurationsDeletedItem = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.delete);

export const selectScheduledTaskConfigurationsearchedItems = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.search);

export const selectScheduledTasksConfigurationsItemsCount = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.count);

export const selectScheduledTasksConfigurationsItemsFilter = createSelector([selectScheduledTasksConfigurations], (scheduledTasksConfigurations) => scheduledTasksConfigurations.filter);